<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Shto kërkesë</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <form>
            <div class="col-12">
              <div class="white-background mb-30">
                <div class="form-group">
                  <label>Të dhënat për kërkesë të re</label>
                  <input
                    type="text"
                    placeholder="emri dhe mbiemri"
                    :value="fullName"
                    @input="getFullName"
                  >
                  <input
                    :class="{'border-danger': formErrors.vehicle_registration_number}"
                    type="text"
                    placeholder="regjistrimi i automjetit"
                    :value="registrationNumber"
                    @input="getRegistrationNumber"
                  >
                  <select
                    :class="{'border-danger': formErrors.status}"
                    style="color: black; paddingTop: 10px; paddingBottom: 10px"
                    class="select-cars width-30"
                    name="vehicle-type"
                    :value="requestStatus"
                    @input="getRequestStatus"
                  >
                    <option style="color: black" value disabled selected>Statusi i kerkeses</option>
                    <option style="color: black" value="awaiting">Ne pritje</option>
                    <option style="color: black" value="on_the_way">Rruges</option>
                    <option style="color: black" value="shipped">Ka arritur</option>
                    <option style="color: black" value="done">E perfunduar</option>
                  </select>
                  <input
                    :class="{'border-danger': formErrors.vehicle_type}"
                    type="text"
                    placeholder="Marka e automjetit"
                    :value="carBrand"
                    @input="getCarBrand"
                  >
                  <input
                    :class="{'border-danger': formErrors.vehicle_color}"
                    type="text"
                    placeholder="Ngjyra e automjetit"
                    :value="carColor"
                    @input="getCarColor"
                  >
                  <select
                    style="color: black; paddingTop: 10px; paddingBottom: 10px"
                    class="select-cars width-30"
                    name="tow-truck"
                    :value="truckId"
                    @input="getTruckId"
                  >
                    <option style="color: black" value disabled selected>Zgjedhni marimangen</option>
                    <option
                      style="color: black"
                      v-for="truck in availableTrucks"
                      :key="truck.id"
                      :value="truck.id"
                    >{{ `Marimanga #${truck.id} ${truck.phone_number} @ ${truck.address}` }}</option>
                  </select>
                  <input
                    :class="{'border-danger': formErrors.longitude}"
                    type="text"
                    placeholder="Longitude"
                    :value="longitude"
                    @input="getLongitude"
                  >
                  <input
                      :class="{'border-danger': formErrors.latitude}"
                      type="text"
                      placeholder="Latitude"
                      :value="latitude"
                      @input="getLatitude"
                  >
                  <input
                      :class="{'border-danger': formErrors.address}"
                      type="text"
                      placeholder="Address"
                      :value="address"
                      @input="getAddress"
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex flex-column flex-sm-row justify-content-between confirmation">
                <router-link class="mb-2 mb-md-0" tag="button" to="/admin">anulo</router-link>
                <button type @click="addRequest">konfirmo</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";



export default {
  name: "AdminAddRequest",
  mounted () {
    // this.$Progress.start();
  },
  components: {

    AdminSidebar: AdminSidebar
  },
  methods: {
    getFullName(e) {
      this.$store.dispatch("requests/getFullName", e.target.value);
    },
    getLongitude(e) {
      this.$store.dispatch("requests/getLongitude", e.target.value);
    },
    getLatitude(e) {
      this.$store.dispatch("requests/getLatitude", e.target.value);
    },
    getCarBrand(e) {
      this.$store.dispatch("requests/getCarBrand", e.target.value);
    },
    getRegistrationNumber(e) {
      this.$store.dispatch("requests/getRegistrationNumber", e.target.value);
    },
    getTruckId(e) {
      this.$store.dispatch("requests/getTruckId", e.target.value);
    },
    getRequestStatus(e) {
      this.$store.dispatch("requests/getRequestStatus", e.target.value);
    },
    getAddress(e) {
      this.$store.dispatch("requests/getAddress", e.target.value);
    },
    getCarColor(e) {
      this.$store.dispatch("requests/getCarColor", e.target.value);
    },
    addRequest(e) {
      e.preventDefault();
      this.$store.dispatch("requests/addRequest");
    }
  },
  computed: {
    ...mapGetters({
      fullName: "requests/fullName",
      longitude: "requests/longitude",
      latitude: "requests/latitude",
      carBrand: "requests/carBrand",
      registrationNumber: "requests/registrationNumber",
      truckId: "requests/truckId",
      requestStatus: "requests/requestStatus",
      address: "requests/address",
      carColor: "requests/carColor",
      availableTrucks: "trucks/availableTrucks",
      formErrors: "requests/formErrors"
    })
  },
  beforeMount() {
    this.$store.commit("requests/GET_FORM_ERRORS", []);
    this.$store.dispatch("trucks/getTrucksList");
    this.$store.dispatch("requests/resetRequestState");
  }
};
</script>
